<template>
  <CandidateLayout
    tab="General"
    :candidate="candidate"
    :applies="applies"
    :apply="apply"
    :recruiter_id="recruiter_id"
    :skills="skills"
    :other_avatar="other_avatar"
  >
  </CandidateLayout>
</template>

<script>
import CandidateLayout from "@/Recruiters/TalentBank/Candidates/CandidateLayout.vue";
import Resume from "@/Recruiters/TalentBank/Candidates/Resume.vue";
import AllApplies from "@/Recruiters/TalentBank/Candidates/AllApplies.vue";
export default {
  props: [
    "candidate",
    "applies",
    "apply",
    "recruiter_id",
    "skills",
    "other_avatar",
  ],
  components: { CandidateLayout, Resume, AllApplies },
  data: () => ({
    tab: "General",
  }),
};
</script>
